export var IS_DEV = process.env.REACT_APP_ENV === 'development';
export var IS_STAGING = process.env.REACT_APP_ENV === 'staging';
export var IS_PROD = process.env.REACT_APP_ENV === 'production';
export var IS_TESTING = !!window.Cypress;
/**
 * @deprecated use IS_STAGING
 */

export var IS_TEST = IS_STAGING;
export var HAS_WINDOW = typeof window !== 'undefined';